// Opening Balance Vuex

import state from './openingBalanceStates.js'
import * as getters from './openingBalanceGetters.js'
import * as mutations from './openingBalanceMutations.js'
import * as actions from './openingBalanceActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
